export default class FeaturesPage {

    constructor(options) {
        this.options = $.extend({
            node: $('.features-sidebar')
        }, options);

        this._initModalLink();
        this._initCategory();
        this._initCategoryHash();
        this._initFilter();

        if (!window.location.hash) {
            let $popularCategoryItem = $('.features-sidebar__category-item[href="#popular"]');
            $popularCategoryItem.get(0).click();
        }
    }

    _initModalLink() {
        let $featureCategoryDescription = $('.features-category');
        let $featureItems = $('.features-list__item');
        let $linksInModal = $('.features__modal a');

        let $categoryItems = $('.features-sidebar__category-item');
        let $featuresList = $('.features-list');
        let $paymentMethodsList = $('.features-payments');

        $linksInModal.on('click', function () {
            let $modal = $(this).closest('.modal');
            $modal.modal('hide');

            $featureItems.hide();
            $featureCategoryDescription.hide();

            let $modalLink = $(this).attr('href').slice(1);

            if ($modalLink == 'payment-integrations') {
                $featuresList.hide();
                $paymentMethodsList.show();
            }

            $featureItems.each(function() {
                if ($modalLink == $(this).data('id')) {
                    $featureItems.filter('[data-id="' + $modalLink + '"]').show();
                } else if ($(this).data('category').includes($modalLink)) {
                    $(this).show();
                }
            });

            $categoryItems.each(function () {
                if ($modalLink == $(this).data('id')) {
                    $(this).addClass('active');
                } else {
                    $(this).removeClass('active');
                }
            });
        });
    }

    _initCategory() {

        let $featuresList = $('.features-list');
        let $paymentMethodsList = $('.features-payments');
        let $featuresNotFound = $('.features-not-found');
        let $searchInput = $('.features-search__input');
        let $searchClearIcon = $('.features-search__input-clear');

        let $featuresWrapper = $('.features__wrapper');

        $('.features-sidebar__category-item', this.options.node).on('click', (event) => {

            let $target = $(event.currentTarget);
            let $toggleAttribute = $target.data('id');

            $target.addClass('active');

            $featuresList.attr('class', 'features-list')
            $featuresList.addClass($target.data('id'));

            if ($toggleAttribute == 'payment-integrations') {
                $featuresList.hide();
                $paymentMethodsList.show();
                $featuresNotFound.hide();
                $searchClearIcon.hide().attr('aria-hidden', 'true');
                $searchInput.val('');
                $searchInput.addClass('features-search__input-empty');
            } else {
                $featuresList.show();
                $paymentMethodsList.hide();
            }

            $('.features-list__item, .features-category').each(function () {
                if ($(this).data('category').includes($toggleAttribute)) {
                    $(this).show();
                } else {
                    $(this).hide();
                }
            });

            $('.features-list__item').each(function () {
                if ($(this).data('category').includes($toggleAttribute)) {
                    $(this).show();
                } else {
                    $(this).hide();
                }
            });

            $('.features-sidebar__category-item', this.options.node).not($target).removeClass('active');

            var HEADER_OFFSET = 70;
            setTimeout(function () {
                var top = $featuresWrapper.offset().top - HEADER_OFFSET;

                $('html, body').stop(true).animate(
                    { scrollTop: top },
                    500
                );
            }, 0);
        });
    }

    _initCategoryHash() {
        let $categoryItems = $('.features-sidebar__category-item', this.options.node);
        let $featureItems = $('.features-list__item');
        let $featureCategoryDescription = $('.features-category');
        let $paymentMethodsList = $('.features-payments');
        let $featuresList = $('.features-list');
        let $searchFilterSelect = $('.features-search__filter-select');
        let $searchFilterValue = $('.features-search__filter-option');

        let $windowHash = window.location.hash.slice(1);

        $featuresList.attr('class', 'features-list')
        $featuresList.addClass($windowHash);

        $categoryItems.each(function () {
            if ($(this).data('id') == $windowHash) {
                $(this).addClass('active');
                $searchFilterValue.html($(this).html());
                $searchFilterSelect.addClass('features-search__filter-select--selected');
            }
        });

        $featureItems.each(function () {
            if ($(this).data('category').includes($windowHash)) {
                $(this).show();
            } else if ($windowHash == '') {
                $(this).show();
            } else if ($(this).data('id').includes($windowHash)) {
                $(this).show();
            } else {
                $(this).hide()
            }
        });

        $featureCategoryDescription.each(function () {
            if ($(this).data('category') == $windowHash) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });

        if ($windowHash == 'payment-integrations') {
            $paymentMethodsList.show();
            $featuresList.hide();
        } else {
            $paymentMethodsList.hide();
            $featuresList.show();
        }
    }

    _initFilter() {
        let $featuresList = $('.features-list');
        let $featuresCategoryInfo = $('.features-category');
        let $filterItems = $('.features-list__item');
        let $featuresNotFound = $('.features-not-found');
        let $searchInput = $('.features-search__input');
        let $searchClearIcon = $('.features-search__input-clear');
        let $searchFilterOpen = $('.features-search__filter');
        let $searchFilterSelect = $('.features-search__filter-select');
        let $searchFilterValue = $('.features-search__filter-option');
        let $searchFilterValueText = $('.features-search__filter-option').html();
        let $searchFilterValueDefaultText = $('.features-search__filter-option--default');
        let $featuresSidebar = $('.features-sidebar');
        let $categoryItem = $('.features-sidebar__category-item');
        let $paymentMethodsList = $('.features-payments');

        $searchInput.on('keyup', function () {
            if ($searchInput.val() != '') {
                $filterItems.hide();
                $featuresNotFound.hide();
                $paymentMethodsList.hide();
                $searchClearIcon.show().removeAttr('aria-hidden');
                $searchInput.removeClass('features-search__input-empty');

                let $foundFilterItems = $filterItems.filter(function () {
                    let $foundFilterTimesTitle = $(this).find('.features-list__item-title').text().toUpperCase();
                    let $foundFilterTimesDescr = $(this).find('.features-list__item-desc').text().toUpperCase();

                    if ($foundFilterTimesTitle.indexOf($searchInput.val().toUpperCase()) > -1 || $foundFilterTimesDescr.indexOf($searchInput.val().toUpperCase()) > -1) {
                        $(this).show();
                        return true;
                    } else {
                        return false;
                    }
                });

                if ($foundFilterItems.length > 0) {
                    $featuresNotFound.hide();
                    $featuresList.show();
                    $paymentMethodsList.hide();
                } else {
                    $featuresNotFound.show();
                    $featuresList.hide();
                    $featuresCategoryInfo.hide();
                }

            } else {
                $filterItems.show();
                $searchClearIcon.hide().attr('aria-hidden', 'true');
                $searchInput.addClass('features-search__input-empty');
            }
        });

        $searchClearIcon.on('click', function () {
            $searchInput.val('');
            $filterItems.show();
            $featuresList.show();
            $featuresNotFound.hide();
            $(this).hide().attr('aria-hidden', 'true');
            $searchInput.addClass('features-search__input-empty');
            $searchInput.trigger('focus');

            if ($categoryItem.hasClass('active')) {
                $categoryItem.removeClass('active');
            }
        });

        $searchFilterOpen.on('click', function (event) {

            let target = event.target;

            if ($(target).hasClass('features-search__filter-close')) {
                $searchFilterOpen.removeClass('features-search__filter--opened');
                $featuresSidebar.removeClass('features-sidebar--opened');
                $searchFilterValue.html($searchFilterValueDefaultText);
                $searchFilterSelect.removeClass('features-search__filter-select--selected');
                $filterItems.show();
                $featuresNotFound.hide();
                $('body').removeClass('filter--opened');

                if ($categoryItem.hasClass('active')) {
                    $categoryItem.removeClass('active');
                }

            } else {
                $(this).addClass('features-search__filter--opened');
                $featuresSidebar.addClass('features-sidebar--opened');
                $('body').addClass('filter--opened');
            }
        });

        $categoryItem.on('click', function () {
            let $categoryTitle = $(this).html();

            $searchFilterValue.html($categoryTitle);
            $searchFilterSelect.addClass('features-search__filter-select--selected');
            $searchFilterOpen.removeClass('features-search__filter--opened');
            $featuresSidebar.removeClass('features-sidebar--opened');
            $('body').removeClass('filter--opened');
        });
    }
}

